import { createRoot } from "react-dom/client";

import App from "@/App";
import "@/index.css";
import { setupKeyboardShortcuts } from "@/utils/keyboardShortcuts";
import { initPerformanceMonitoring } from "@/utils/performance";
import { initErrorTracking } from "@/utils/errorTracking";
import { deferAfterLoad } from "@/utils/deferredInit";

// Accessibility testing in development
if (import.meta.env.DEV) {
  import("@axe-core/react")
    .then(async (axe) => {
      const React = await import("react");
      const ReactDOM = await import("react-dom");
      axe.default(React.default, ReactDOM.default, 1000);
    })
    .catch(() => {
      // Silently fail if axe-core is not available
    });
}

// Initialize keyboard shortcuts for accessibility
const cleanupKeyboardShortcuts = setupKeyboardShortcuts();

// Defer non-critical script initialization to improve first load performance
// These scripts will load after the page is interactive and browser is idle
deferAfterLoad(() => {
  // Initialize performance monitoring (Core Web Vitals)
  // Deferred to avoid blocking initial render
  initPerformanceMonitoring();
}, 2000);

deferAfterLoad(() => {
  // Initialize error tracking (Sentry)
  // Deferred to avoid blocking initial render
  initErrorTracking();
}, 2000);

// Cleanup on page unload
window.addEventListener("beforeunload", () => {
  cleanupKeyboardShortcuts();
});

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

// Mark body as ready once React starts rendering to prevent footer flash
document.body.classList.add("react-ready");

createRoot(rootElement).render(<App />);
